import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    cluster: '', // Leave empty for Reverb
});

/**
 * Testing Channels & Events & Connections
 */
function getUserID() {
    const metaTag = document.querySelector('meta[name="user-id"]');
    return metaTag ? metaTag?.getAttribute('content') : null;
}

const userID = window.userID = getUserID();
